var countdownIntervals = [];

function initializeCountdown(element, countdownIndex) {
	let countdownDate;
	const isMockEnabled =
		element.getAttribute("data-enable-mock-timer") === "true";
	if (isMockEnabled) {
		const mockPickerDay = Number(
			element.getAttribute("data-enable-mock-picker-day")
		);
		const mockPickerHour = Number(
			element.getAttribute("data-enable-mock-picker-hours")
		);

		const nowDate = new Date();
		const mockTargetDate = new Date(
			nowDate.getTime() + (mockPickerDay * 24 + mockPickerHour) * 60 * 60 * 1000
		);
		countdownDate = mockTargetDate;
	} else {
		const userDate = element.getAttribute("data-date");
		const userTime = element.getAttribute("data-time");
		countdownDate = new Date(`${userDate}T${userTime}`);
	}
	const completedCountdown = element.getAttribute("data-completed");

	const countdown = element.querySelector(".information-bar__countdown__main");
	const countdownHeading = element.querySelector(
		".information-bar__countdown__end"
	);
	const countdownTimerBlock = element.querySelector(
		".information-bar__countdown__timer-wrapper"
	);
	const daysEl = element.querySelector(".information-bar__countdown__days");
	const hoursEl = element.querySelector(".information-bar__countdown__hours");
	const minutesEl = element.querySelector(
		".information-bar__countdown__minutes"
	);
	const secondsEl = element.querySelector(
		".information-bar__countdown__seconds"
	);
	const section = element.closest(".information-bar__countdown-section");
	const labels = element.querySelectorAll(".information-bar__countdown__label");

	const container = element.querySelector(
		".information-bar__countdown__text-block"
	);


	//time
	const MS_IN_SEC = 1000;
	const SEC_IN_MIN = 60;
	const MIN_IN_HOUR = 60;
	const HOUR_IN_DAY = 24;

	const SECONDS_IN_HOUR = SEC_IN_MIN * MIN_IN_HOUR;
	const MILLISECONDS_IN_MINUTE = MS_IN_SEC * SEC_IN_MIN;
	const MILLISECONDS_IN_HOUR = MS_IN_SEC * SECONDS_IN_HOUR;
	const MILLISECONDS_IN_DAY = MS_IN_SEC * SECONDS_IN_HOUR * HOUR_IN_DAY;

	const calcDays = (distance) => Math.floor(distance / MILLISECONDS_IN_DAY);

	//animation settings
	const isAnimated = element.dataset.animation === "true";
	const animationSpeed = element.dataset.speed;

	const calcWordsLength = () => {
		if (!labels.length) return 0;

		return [...labels].reduce(
			(sum, label) => sum + label.textContent.trim().length,
			0
		);
	};

	const calcAnimationDuration = (days) =>
		(calcWordsLength() + 6 + `${days}`.length) * animationSpeed;

	const setupCountdownContent = (distance) => {
		const days = calcDays(distance);
		const zeroDays = days == 0;
		const daysBlock = daysEl?.closest(".information-bar__countdown__block");
		const hours = Math.floor(
			(distance % MILLISECONDS_IN_DAY) / MILLISECONDS_IN_HOUR
		);
		const minutes = Math.floor(
			(distance % MILLISECONDS_IN_HOUR) / MILLISECONDS_IN_MINUTE
		);
		const seconds = Math.floor((distance % MILLISECONDS_IN_MINUTE) / MS_IN_SEC);

		if (distance < 0) {
			clearInterval(countdownIntervals[countdownIndex]);
			if (completedCountdown === "hide_section") {
				element
					.closest("section")
					.querySelector(".information-bar__countdown--wrapper").style.display =
					"none";
			} else if (completedCountdown === "show_text") {
				if (countdown) countdown.style.display = "none";
				if (countdownHeading) countdownHeading.style.display = "flex";
				if (countdownTimerBlock)
					countdownTimerBlock.style.justifyContent = "center";

				// hiding the divider in case of no text
				if (
					element
						.closest("section")
						.querySelector(".information-bar__countdown--divider") == null
				)
					return;
				const noDivider =
					element
						.querySelector(".information-bar__countdown__end-text")
						.innerHTML.trim() == "";
				const infoDivider = element
					.closest("section")
					.querySelector(".information-bar__countdown--divider");
				infoDivider.style.display = noDivider ? "none" : "inline-block";
			}
		}

		if (daysEl !== null) {
			if (zeroDays) {
				daysBlock.classList.add("no_days");
			} else {
				daysEl.textContent = String(days).padStart(2, "0");
				daysBlock.classList.remove("no_days");
			}
		}
		if (hoursEl) hoursEl.textContent = String(hours).padStart(2, "0");
		if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, "0");
		if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, "0");
	};

	function updateCountdown(isFirstTime = false) {
		const now = new Date();
		const distance = countdownDate.getTime() - now.getTime();
		const days = calcDays(distance);

		// Ensure animationDuration is calculated correctly
		const animationDuration =
			isAnimated && isFirstTime ? calcAnimationDuration(days) : 0;

		// Adjust distance based on animation duration
		const adjustedDistance = distance - animationDuration;

		setupCountdownContent(adjustedDistance);
	}

	function startCountdown() {
		countdownIntervals[countdownIndex] = setInterval(updateCountdown, 1000);
	}

	async function animateRevealing() {
		if (!isAnimated) return;
		if (Shopify.designMode) return;

		const animatedElements = element.querySelectorAll(
			".information-bar__countdown__number, .information-bar__countdown__label"
		);

		if (!animatedElements.length) return;
		var animCount = 0;
		animatedElements.forEach((item, idx) => {
			item.innerHTML = item.innerHTML
				.trim()
				.split("")
				.map((char, index) => {
					animCount++;
					return `<span class="anim" data-index="${animCount}">${char}</span>`;
				})
				.join("");
		});

		const spans = Array.from(element.querySelectorAll(".anim"));
		const promises = spans.map((anim) => {
			anim.setAttribute("style", `opacity: 0;`);
			let revealDelay = parseInt(anim.dataset.index) * parseInt(animationSpeed);
			return new Promise((resolve) => {
				setTimeout(() => {
					anim.setAttribute("style", `opacity: 1;`);
					resolve();
				}, revealDelay);
			});
		});

		return Promise.all(promises);
	}

	// setup initial numbers
	updateCountdown(true);
	// animate first, then start the countdown
	animateRevealing().then(startCountdown);
}

function initCountdownSections(section) {
	const countdownElements = section.querySelectorAll("countdown-timer");
	countdownElements.forEach((element, idx) =>
		initializeCountdown(element, idx)
	);
}

initCountdownSections(document.currentScript.parentElement);

function setupBorderRadiuses() {
	if (
		document.querySelector(".information-bar__item__menu--list--item") === null
	)
		return;
	let menu_items = document.querySelectorAll(
		".information-bar__item__menu--list--item"
	);
	menu_items.forEach((menu_item) => {
		let menu = menu_item.closest(".information-bar__item__menu");

		menu_item.addEventListener("mouseenter", () => {
			menu.classList.add("submenu-opened");
		});

		menu_item.addEventListener("mouseleave", () => {
			menu.classList.remove("submenu-opened");
		});
	});
}

document.addEventListener("shopify:section:load", (event) => {
	initCountdownSections(event.target);
});

(function () {
	const initSection = (section) => {
		const menu__list = section.querySelector(".aside-menu__list");
		const menu__body = document.querySelector(".aside-menu__body");
		if (!menu__list || !menu__body) return; // sin el shell del drawer no hay nada que mover
		menu__body.appendChild(menu__list);

		const setupSubmenusPos = () => {
			if (
				document.querySelector(
					".information-bar__item__submenu:not(.information-bar__item__submenu_2)"
				) !== null
			) {
				const submenus = document.querySelectorAll(
					".information-bar__item__submenu:not(.information-bar__item__submenu_2)"
				);

				submenus.forEach((submenu) => {
					const rect = submenu.getBoundingClientRect();
					const offsetLeftFromPage = rect.left + window.pageXOffset;
					let spaceRight =
						window.innerWidth - offsetLeftFromPage - submenu.offsetWidth;
					submenu.classList[spaceRight < 5 ? "add" : "remove"]("right-align");
				});
			}
		};

		setupSubmenusPos();

		setupBorderRadiuses();
		window.addEventListener("resize", () => {
			setTimeout(() => setupSubmenusPos(), 1000);
		});
	};

	initSection(document.currentScript.parentElement);

	document.addEventListener("shopify:section:load", function (section) {
		initSection(section.target);
	});
})();
